/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography';
import { ticketColors } from '../../../shared/theme/ticketColors';

type Props = {
  visible: boolean;
  retrying: boolean;
  onRetry: () => void;
};

/**
 * Aviso cuando hay sucursales pero no pudimos cargar el plan/org vía RPC (evita usar la app “a ciegas”).
 */
export function EntitlementsGapBanner({ visible, retrying, onRetry }: Props) {
  if (!visible) return null;

  return (
    <View style={styles.wrap} accessibilityRole="alert">
      <Text style={styles.text}>
        No pudimos cargar el plan y los datos de tu organización. Suele ser un fallo de red o del servidor. Tu cuenta
        sigue usando el plan Gratis hasta que podamos sincronizar.
      </Text>
      <TouchableOpacity
        style={[styles.button, retrying && styles.buttonDisabled]}
        onPress={onRetry}
        disabled={retrying}
        accessibilityRole="button"
        accessibilityLabel="Reintentar cargar plan y organización"
      >
        {retrying ? (
          <ActivityIndicator color={ticketColors.ink} size="small" />
        ) : (
          <Text style={styles.buttonText}>Reintentar</Text>
        )}
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    backgroundColor: ticketColors.paper,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    gap: spacing.sm,
  },
  text: {
    ...typography.caption,
    color: ticketColors.ink2,
    textAlign: 'center',
  },
  button: {
    alignSelf: 'center',
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.md,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.bg,
    minWidth: 120,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonDisabled: {
    opacity: 0.6,
  },
  buttonText: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '600',
  },
});
